import { get_token, get_user_id, getCookie } from '@/router/index.js';
import { get_domain_style } from '@/main';


export default {
  name: 'SidebarView',

  data: () => ({
    orcaa_url: process.env.VUE_APP_ORCAA_URL,
    proba_workflows_url: process.env.VUE_APP_PROBA_WORKFLOWS_URL,
    complyon_url: process.env.VUE_APP_COMPLYON_URL,
    engagenet_url: process.env.VUE_APP_ENGAGENET_URL,
    x_verdict_url: process.env.VUE_APP_X_VERDICT_URL,
    proba_analytics_url: process.env.VUE_APP_PROBA_ANALYTICS_URL,

    user: {},
    is_admin: false,
    is_collapsed: false,
    settings_menu_open: false,
    is_internal_suite: false,
    is_demo_domain: true,
    is_demo_aic_one_domain: false,
  }),

  computed: {
    styleConfig() {
      return get_domain_style();
    },
    demo_allowed_apps() {
      return this.styleConfig.allowed_apps;
    },

  },

  mounted() {
    const host = (window.location.hostname || "").toLowerCase();
    this.is_demo_aic_one_domain = host === "demo.aic-one.com";
    this.is_internal_suite =
    host === "1campus.aic-one.com" ||
    host.includes("1campus") ||
    host.includes("1campus");

    this.csrf_token = getCookie('csrftoken');
    const current_domain = window.location.hostname;
    this.is_demo_domain = !current_domain.includes('demo.live.aic-one.com');

     // Load saved collapse state from localStorage
    const saved_state = localStorage.getItem('sidebarCollapsed');
    if (saved_state !== null) {
      this.is_collapsed = saved_state === 'true';
    }

    // Apply initial body class
    this.update_body_class();

    // Restore from localStorage for instant rendering
    const stored_user = localStorage.getItem('user');
    const stored_is_admin = localStorage.getItem('is_admin');

    if (stored_user) {
      this.user = JSON.parse(stored_user);
    }
    if (stored_is_admin !== null) {
      this.is_admin = stored_is_admin === 'true';
    }

    // Refresh user details in background
    this.get_user_details();


  },

  methods: {

    toggle_settings_menu() {
      this.settings_menu_open = !this.settings_menu_open;
    },
    close_settings_menu_on_mobile() {
      // Only close if the screen is mobile-sized (optional, but good practice)
      if (window.innerWidth <= 576) {
        this.settings_menu_open = false;
      }
    },
    toggle_collapse() {
      this.is_collapsed = !this.is_collapsed;
      // Save state to localStorage
      localStorage.setItem('sidebarCollapsed', this.is_collapsed);

      // Update body class for main content adjustment
      this.update_body_class();

      // Emit event to parent component if needed
      this.$emit('sidebar-toggled', this.is_collapsed);
    },
    update_body_class() {
      if (this.is_collapsed) {
        document.body.classList.add('sidebar-collapsed');
      } else {
        document.body.classList.remove('sidebar-collapsed');
      }
    },
    async logout() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/user_logout/';
      const user_id = get_user_id();
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }
      try {
        await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-Page-URL': window.location.href,
            'X-CSRFToken': this.csrf_token
          },

        body: JSON.stringify({ user_id })
        });

        localStorage.clear();
        this.$router.push('/');
      } catch (error) {
        this.$notyf.info('Logout Failed');

      }
    },

    async launch_platform(plaform) {
      const token = get_token();

       if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }
      const user_id = get_user_id();
      const platform = String(plaform || '').toLowerCase();

      const is_valid_key = /^[a-zA-Z0-9_-]+$/.test(platform);
      if (!is_valid_key) {
        this.$notyf.error('Unknown platform: invalid key');
        return;
      }

      const endpoint_map = Object.freeze({
      'x-verdict': '/aic_one_api/system_management/launch_xverdict/',
      'orcaa': '/aic_one_api/system_management/launch_orcaa/',
      'proba': '/aic_one_api/system_management/launch_proba/',
      'engagenet': '/aic_one_api/system_management/launch_engagenet/',
      'workflow': '/aic_one_api/system_management/launch_proba_workflow/',
      'complyon': '/aic_one_api/system_management/launch_complyon/',
      'complyon_onboard': '/aic_one_api/system_management/launch_complyon_onboard/',
      });

      const desc = Object.getOwnPropertyDescriptor(endpoint_map, platform);
      const path = (desc && desc.enumerable && typeof desc.value === 'string') ? desc.value : null;

      if (!path) {
        this.$notyf.error(`Unknown platform: ${platform}`);
        return;
      }

      const api_url = `${process.env.VUE_APP_API_BASE_URL}${path}`;

      try {
        const res = await fetch(api_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-Page-URL': window.location.href,
          },
          body: JSON.stringify({ user_id })
        });

        // Parse JSON once
        const data = await res.json();

        if (!res.ok) {
          let msg = data.message || 'Failed to launch';

          // ---- CLEAN DUPLICATE WORDS ---
          msg = msg.replace(/\b(\w+)\s+\1\b/gi, "$1");
          msg = msg.replace(/\bLaunch\s+Launch\b/gi, "Launch");
          this.$notyf.error(msg);
          return;
        }

        // Handle success paths
        if (data.status === 'success' && data.redirect_url) {
          window.location = data.redirect_url;
        } else {
          this.$notyf.error('Failed to launch platform');
        }

      } catch (error) {
        this.$notyf.error('Failed to launch');
      }

    },


    async get_user_details() {
      const api_url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_current_user/`;
      const token = get_token();

      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const response = await fetch(api_url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrf_token
          },
        });

        if (response.ok) {
          const response_data = await response.json();
          this.user = response_data.data;
          this.is_admin = this.user && this.user.role && this.user.role.toLowerCase().includes('admin');

          // Persist to localStorage
          localStorage.setItem('user', JSON.stringify(this.user));
          localStorage.setItem('is_admin', this.is_admin);
        } else {
          this.$notyf.info('Error fetching user');
        }
      } catch (error) {
        this.$notyf.info('Error fetching user');
      }
    },
  },
};
